import { render, staticRenderFns } from "./DatasetCollectionUIWrapper.vue?vue&type=template&id=10325848&"
import script from "./DatasetCollectionUIWrapper.vue?vue&type=script&lang=js&"
export * from "./DatasetCollectionUIWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports